<template>
  <div class="col-12">
    <div class="group-input col-12 row q-mt-sm">
      <RequiredLabel
        title="Informar o máximo de numerais não cabeados a direita, a esquerda e na calçada oposta"
        name="numerais_nao_cabeados"
      />
      <q-input
        class="col-12 q-mt-sm form-tabulacao"
        outlined
        dense
        color="red-9"
        use-input
        fill-input
        name="numerais_nao_cabeados"
        input-debounce="0"
        placeholder="Digite aqui"
        v-model="itemOsContract.numerais_nao_cabeados"
        bg-color="white"
        lazy-rules
        :rules="[(val) => !!val || 'Campo Obrigatório']"
      />
    </div>
    <div class="group-input col-12 row q-mt-sm">
      <RequiredLabel
        title="Ponto de referência (travessas e paralelas)"
        name="ponto_de_referencia"
      />
      <q-input
        class="col-12 q-mt-sm form-tabulacao"
        outlined
        dense
        color="red-9"
        use-input
        name="ponto_de_referencia"
        v-model="itemOsContract.ponto_de_referencia"
        fill-input
        input-debounce="0"
        placeholder="Digite aqui"
        bg-color="white"
        lazy-rules
        :rules="[(val) => !!val || 'Campo Obrigatório']"
      />
    </div>
    <div class="group-input col-12 row q-mt-sm">
      <RequiredLabel
        title="Quantos metros aproximadamente fora de rede"
        name="metros_fora_de_rede"
      />
      <q-input
        class="col-12 q-mt-sm form-tabulacao"
        outlined
        dense
        color="red-9"
        use-input
        name="metros_fora_de_rede"
        v-model="itemOsContract.metros_fora_de_rede"
        fill-input
        input-debounce="0"
        placeholder="Digite aqui"
        bg-color="white"
        lazy-rules
        :rules="[(val) => !!val || 'Campo Obrigatório']"
      />
    </div>
    <div class="group-input col-12 row q-mt-sm">
      <RequiredLabel
        title="Informações da última TAP de rede"
        name="ultima_tap_de_rede"
      />
      <q-input
        class="col-12 q-mt-sm form-tabulacao"
        outlined
        dense
        color="red-9"
        name="ultima_tap_de_rede"
        v-model="itemOsContract.ultima_tap_de_rede"
        use-input
        fill-input
        input-debounce="0"
        placeholder="Digite aqui"
        bg-color="white"
        lazy-rules
        :rules="[(val) => !!val || 'Campo Obrigatório']"
      />
    </div>
  </div>
</template>

<script>
  import RequiredLabel from "@/components/SpecialCodes/RequiredLabel.vue";
import { inject, onBeforeMount } from "vue";

  export default {
    name: "NodeNotReleasedForm",
    components: {
      RequiredLabel,
    },
    props: {
      itemOsContract: Object,
    },

    setup(props, { emit }) {
      let requestData = {
        numerais_nao_cabeados: "",
        ponto_de_referencia: "",
        metros_fora_de_rede: "",
        ultima_tap_de_rede: "",
      };

      const addFieldsToRequestData = inject("addFieldsToRequestData");
      onBeforeMount(() => {
        addFieldsToRequestData(requestData);
      });

      return {
        requestData,
      };
    },
  };
</script>

<style scoped lang="scss">
  label {
    font-family: Roboto;
    font-style: normal;
  }
  .group-input {
    label {
      font-weight: bold;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.4);
    }
  }
</style>
